<template>
  <b-modal
    modal-class="document-modal form-group-view-modal"
    v-model="editorShown"
    size="xl"
    no-close-on-backdrop
    hide-header
    hide-footer
    centered
  >
    <div class="d-flex h-100" v-if="showViewModal">
      <div class="sidebar-forms-container bg-extra-light-gray">
        <template v-if="group">
          <div class="font-weight-bold px-3 my-3" style="font-size:16px;">
            Group Notes
          </div>
          <div class="sidebar-forms">
            <div
              v-for="linkedDocument in linkedDocuments"
              :key="linkedDocument.document.id"
              @click="setDocument(linkedDocument)"
              class="sidebar-menu-form-item d-flex align-items-center"
              :class="
                document && document.documentId == linkedDocument.document.id
                  ? 'active'
                  : ''
              "
            >
              <span
                class="status-circle"
                :class="getFormDocumentColor(linkedDocument.document)"
              />
              <span
                class="ml-2 no-wrap-text"
                :id="
                  `form-${linkedDocument.formId}-eoc-${linkedDocument.episodeOfCare.id}`
                "
              >
                <b-tooltip
                  :target="
                    `form-${linkedDocument.formId}-eoc-${linkedDocument.episodeOfCare.id}`
                  "
                  placement="bottom"
                  triggers="hover"
                >
                  <small>
                    <div>{{ linkedDocument.form.name }}</div>
                    <div>
                      <span
                        class="badge text-white"
                        :style="
                          `background-color: ${linkedDocument.scheduleEventStatus.color}; min-width: 21px;`
                        "
                      >
                        {{
                          linkedDocument.scheduleEventStatus.name
                            .replace(/\s/g, "")
                            .replace(/[a-z]/g, "")
                        }}
                      </span>
                      {{ formatEocObj(linkedDocument.episodeOfCare) }}
                    </div>
                  </small>
                </b-tooltip>
                <div class="d-flex flex-column" style="font-size:13px;">
                  <div style="white-space: initial; padding-right: 7px;">
                    {{ linkedDocument.form.name }}
                  </div>
                  <div style="white-space: initial; padding-right: 7px;">
                    <span
                      class="badge text-white"
                      :style="
                        `background-color: ${linkedDocument.scheduleEventStatus.color}; min-width: 21px;`
                      "
                    >
                      {{
                        linkedDocument.scheduleEventStatus.name
                          .replace(/\s/g, "")
                          .replace(/[a-z]/g, "")
                      }}
                    </span>
                    {{ formatEocObj(linkedDocument.episodeOfCare) }}
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div
            class="d-flex flex-column align-items-center my-3"
            style="gap: 10px"
          >
            <template v-if="groupHtml">
              <b-button
                pill
                variant="outline-primary"
                style="width: 125px"
                @click="() => showReorderModal(sendFax, 'Fax All')"
              >
                Fax All
              </b-button>
              <b-button
                pill
                variant="outline-primary"
                style="width: 125px"
                :disabled="downloadingPDF"
                @click="() => showReorderModal(savePdfGroup, 'Download All')"
              >
                Download All
              </b-button>
              <b-button
                pill
                variant="outline-primary"
                style="width: 125px"
                @click="() => showReorderModal(printGroup, 'Print All')"
              >
                Print All
              </b-button>
            </template>
          </div>
        </template>
      </div>
      <div
        class="main-container d-flex flex-column bg-white border-radius-top border-radius-bottom"
        :style="{
          width: 'calc(100% - 600px)',
          zIndex: 2
        }"
      >
        <div
          class="d-flex flex-row justify-content-between align-items-center bg-purple text-white border-radius-top"
          style="padding: 10px 20px;"
        >
          <div>
            <h5 class="modal-title font-weight-bold mb-1">{{ modalTitle }}</h5>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            style="opacity:1 !important"
            @click="editorShown = false"
          >
            ×
          </button>
        </div>
        <div class="text-center h-100" v-if="document">
          <iframe
            v-if="document.mode == 'File'"
            :src="url"
            class="w-100 h-100 p-3"
            frameBorder="0"
            style="max-width: 900px"
            :id="document.documentId"
          />
          <zoom-area
            ref="documentZoomArea"
            :hideControls="true"
            v-else
            width="1025px"
          >
            <vue-html2pdf
              :show-layout="false"
              :float-layout="false"
              :pdf-quality="2"
              :pdf-content-width="'100%'"
              :paginate-elements-by-height="1500"
              class="w-100"
            >
              <template slot="pdf-content">
                <div
                  v-if="singleHtml"
                  v-html-sanitize="singleHtml"
                  :id="document.documentId"
                  class="m-4"
                />
              </template>
            </vue-html2pdf>
          </zoom-area>
        </div>
        <div
          class="d-flex justify-content-between align-items-center w-100 bg-extra-light-gray position-relative border-top mt-auto border-top border-radius-bottom"
          style="padding: 10px 20px;"
        >
          <div>
            <template v-if="singleHtml">
              <b-button
                v-if="
                  document.status != 'Completed' ||
                    hasCurrentUserDocumentPermission(
                      document.form.id,
                      'hasCompleteAccess'
                    )
                "
                class="mr-2"
                variant="primary"
                @click="editDocument"
              >
                Edit
              </b-button>
              <b-button class="mr-2" variant="primary" @click="printSingle">
                Print
              </b-button>
              <b-button
                v-if="document"
                class="mr-2"
                variant="primary"
                :disabled="downloadingPDF"
                @click="savePdfSingle"
              >
                Download
              </b-button>
              <b-button
                v-if="document"
                class="mr-2"
                variant="primary"
                @click="sendFax(false)"
              >
                Fax
              </b-button>
            </template>
          </div>
          <div style="font-size: 20px">
            <i
              @click="addDocumentZoomArea()"
              class="fa fa-search-plus zoom-control hover-text-primary"
            ></i>
            <i
              @click="lessDocumentZoomArea()"
              class="fa fa-search-minus zoom-control hover-text-primary"
            ></i>
          </div>
          <div style="width: 236px; text-align: right;">
            <b-button @click="editorShown = false" variant="secondary">
              Close
            </b-button>
          </div>
        </div>
      </div>
      <div class="sidebar">
        <div class="sidebar-inner h-100 my-2">
          <div class="d-flex p-2 mb-3">
            <div
              class="sidebar-tab-title px-3 text-primary border-bottom border-primary"
            >
              NOTES
            </div>
          </div>
          <div class="position-relative d-flex h-100">
            <document-notes-tab-content
              :documentId="document && document.documentId"
            />
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf
      ref="html2PdfSingle"
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :pdf-quality="2"
      :pdf-content-width="'1025px'"
      :paginate-elements-by-height="1500"
      :html-to-pdf-options="pdfSingle"
      class="position-fixed w-100"
      style="top: 1000%"
      @hasDownloaded="hasDownloaded"
    >
      <template slot="pdf-content"> </template>
    </vue-html2pdf>
    <vue-html2pdf
      ref="html2PdfGroup"
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :pdf-quality="2"
      :pdf-content-width="'1025px'"
      :paginate-elements-by-height="1500"
      :html-to-pdf-options="pdfGroup"
      class="position-fixed w-100"
      style="top: 1000%"
      @hasDownloaded="hasDownloaded"
    >
      <template slot="pdf-content"> </template>
    </vue-html2pdf>
    <group-session-notes-add-edit-modal
      v-if="groupNotesEditor.show"
      v-model="groupNotesEditor.show"
      @onModify="onModify"
      :scheduleEvent="group"
      :initialDocument="groupNotesEditor.initialDocument"
    />
    <send-fax-modal
      v-if="showFaxModal"
      v-model="showFaxModal"
      :ids="this.ids"
      :sendFaxMethod="this.sendFaxMethod"
    ></send-fax-modal>
    <document-reorder
      v-if="documentReorderModal.show"
      v-model="documentReorderModal.show"
      :documents="documentReorderModal.documents"
      :actionLabel="documentReorderModal.actionLabel"
      @onModify="onModifyDocumentReorder"
      @onReorder="onReorder"
    />
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import documentServer from "../../server/document";
import scheduleEventServer from "../../server/scheduleEvent";
import formSubmitterServer from "../../server/formSubmitter";
import VueHtml2pdf from "vue-html2pdf";
import ZoomArea from "../controls/ZoomArea";
import DocumentNotesTabContent from "../episode_of_care/document/DocumentNotesTabContent.vue";
import GroupSessionNotesAddEditModal from "./GroupSessionNotesAddEditModal.vue";
import SendFaxModal from "../fax/SendFaxModal.vue";
import DocumentReorder from "../episode_of_care/document/DocumentReorder.vue";

export default {
  name: "GroupSessionViewModal",
  components: {
    VueHtml2pdf,
    ZoomArea,
    DocumentNotesTabContent,
    GroupSessionNotesAddEditModal,
    SendFaxModal,
    DocumentReorder
  },
  props: ["groupId"],
  data() {
    return {
      showViewModal: true,
      ids: [],
      sendFaxMethod: "",
      group: null,
      document: null,
      eoc: null,
      participantId: null,
      singleUrl: null,
      singleHtml: null,
      singleBlob: null,
      singleBlobUrl: null,
      groupUrl: null,
      groupHtml: null,
      groupBlob: null,
      groupBlobUrl: null,
      downloadingPDF: false,
      groupNotesEditor: {
        show: false,
        initialDocument: {
          participantId: null,
          formId: null
        }
      },
      showFaxModal: false,
      documentReorderModal: {
        show: false,
        documents: null,
        callback: () => {},
        actionLabel: ""
      },
      reorderedDocuments: []
    };
  },
  async mounted() {
    this.group = await scheduleEventServer.get(this.groupId);
    this.reorderedDocuments = this.linkedDocuments.map(document => ({
      value: document.document.id,
      label: `${document.form.name} (${this.formatEocObj(
        document.episodeOfCare
      )})`
    }));
    this.setDocument(this.linkedDocuments[0]);
    this.loadGroup();
  },
  methods: {
    ...mapActions("layout", ["show", "hide"]),
    async setDocument(linkedDocument) {
      this.eoc = linkedDocument.episodeOfCare;
      this.participantId = linkedDocument.participantId;
      this.document = await formSubmitterServer.getDetailedImproved(
        linkedDocument.document.id
      );
      this.loadSingle();
    },
    loadSingle() {
      if (!this.document) {
        return;
      }

      this.singleUrl = documentServer.documentsViewUrl([
        this.document.documentId
      ]);

      fetch(this.singleUrl.url, { headers: this.singleUrl.headers }).then(
        response => {
          const clone = response.clone();

          response.blob().then(blob => {
            this.singleBlobUrl = URL.createObjectURL(blob);
          });

          clone.text().then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            this.singleHtml = doc.body.innerHTML.replace(/vh-100/gi, "");

            const content = this.$refs.html2PdfSingle.$el.querySelector(
              ".content-wrapper"
            );
            const fragment = document
              .createRange()
              .createContextualFragment(this.singleHtml);

            content.appendChild(fragment);

            requestAnimationFrame(() => {
              Array.from(content.querySelectorAll(".document-single")).forEach(
                singleDoc => {
                  const rect = singleDoc.getBoundingClientRect();
                  singleDoc.style.transform = "scale(0.6925)";
                  singleDoc.style.transformOrigin = "0% 0% 0px";
                  singleDoc.style.height = `${rect.height * 0.6925}px`;
                }
              );
            });
          });
        }
      );
    },
    loadGroup() {
      this.groupUrl = documentServer.documentsViewUrl([
        this.linkedDocuments.map(f => f.document.id)
      ]);

      fetch(this.groupUrl.url, { headers: this.groupUrl.headers }).then(
        response => {
          const clone = response.clone();

          response.blob().then(blob => {
            this.groupBlobUrl = URL.createObjectURL(blob);
          });

          clone.text().then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            this.groupHtml = doc.body.innerHTML.replace(/vh-100/gi, "");

            const content = this.$refs.html2PdfGroup.$el.querySelector(
              ".content-wrapper"
            );
            const fragment = document
              .createRange()
              .createContextualFragment(this.groupHtml);

            content.appendChild(fragment);

            requestAnimationFrame(() => {
              Array.from(content.querySelectorAll(".document-single")).forEach(
                singleDoc => {
                  const rect = singleDoc.getBoundingClientRect();
                  singleDoc.style.transform = "scale(0.6925)";
                  singleDoc.style.transformOrigin = "0% 0% 0px";
                  singleDoc.style.height = `${rect.height * 0.6925}px`;
                }
              );
            });
          });
        }
      );
    },
    getFormDocumentColor(document) {
      if (document) {
        if (document.status == "Completed") return "success";
        if (document.status == "Pending") return "warning";
        return "draft";
      }
    },
    editDocument() {
      this.showViewModal = false;
      this.groupNotesEditor.initialDocument.participantId = this.participantId;
      this.groupNotesEditor.initialDocument.formId = this.document.form.id;
      this.groupNotesEditor.show = true;
    },
    onModify(e) {
      this.groupNotesEditor.initialDocument.participantId = null;
      this.groupNotesEditor.initialDocument.formId = null;
      this.groupNotesEditor.show = false;
      this.editorShown = false;

      this.$emit("onModify", e);
    },
    savePdfSingle() {
      let ids = [this.document.documentId];
      this.downloadingPDF = true;
      const filename = this.pdfSingle.filename;

      this.show();
      documentServer
        .downloadDocumentPdf(ids)
        .then(res => {
          res.blob().then(blob => {
            let fileURL = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = fileURL;
            link.download = filename;
            link.dispatchEvent(new MouseEvent("click"));
          });
        })
        .finally(() => {
          this.hide();
          this.downloadingPDF = false;
        });
    },
    onReorder({ reorderedDocuments }) {
      this.reorderedDocuments = reorderedDocuments;
      this.documentReorderModal.callback();
    },
    onModifyDocumentReorder() {
      this.documentReorderModal = {
        show: false,
        documents: [],
        callback: () => {},
        actionLabel: ""
      };
    },
    showReorderModal(callback, actionLabel) {
      this.documentReorderModal = {
        show: true,
        documents: this.reorderedDocuments,
        callback,
        actionLabel
      };
    },
    savePdfGroup() {
      this.downloadingPDF = true;
      const filename = this.pdfSingle.filename;

      this.show();
      documentServer
        .downloadDocumentPdf(this.reorderedDocuments.map(doc => doc.value))
        .then(res => {
          res.blob().then(blob => {
            let fileURL = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = fileURL;
            link.download = filename;
            link.dispatchEvent(new MouseEvent("click"));
          });
        })
        .finally(() => {
          this.downloadingPDF = false;
          this.hide();
        });
    },
    printSingle() {
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.zIndex = -100;
      iframe.style.width = "2250px";
      iframe.src = this.singleBlobUrl;
      iframe.onload = function() {
        iframe.contentWindow.onafterprint = function() {
          document.body.removeChild(iframe);
        };

        setTimeout(() => {
          iframe.contentWindow.print();
        }, 500);
      };

      document.body.appendChild(iframe);
    },

    printGroup() {
      this.groupUrl = documentServer.documentsViewUrl(
        this.reorderedDocuments.map(d => d.value)
      );
      fetch(this.groupUrl.url, { headers: this.groupUrl.headers }).then(
        response => {
          response.blob().then(blob => {
            this.groupBlobUrl = URL.createObjectURL(blob);
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.zIndex = -100;
            iframe.style.width = "2250px";
            iframe.src = this.groupBlobUrl;
            iframe.onload = function() {
              iframe.contentWindow.onafterprint = function() {
                document.body.removeChild(iframe);
              };

              setTimeout(() => {
                iframe.contentWindow.print();
              }, 500);
            };

            document.body.appendChild(iframe);
          });
        }
      );
    },
    hasDownloaded() {
      this.downloadingPDF = false;
    },
    addDocumentZoomArea() {
      this.$refs.documentZoomArea.addZoom();
    },
    lessDocumentZoomArea() {
      this.$refs.documentZoomArea.lessZoom();
    },
    sendFax(allDocuments = true) {
      this.sendFaxMethod = "sendDocumentsPdf";
      this.ids = this.reorderedDocuments.map(doc => doc.value);
      if (!allDocuments) {
        this.ids = [this.document.documentId];
      }

      this.showFaxModal = true;
    }
  },
  computed: {
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    ...mapGetters("formGroupSubmitter", ["getFormGroupSubmitById"]),
    ...mapGetters("formGroup", ["getFormGroupById"]),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    modalTitle() {
      return this.eoc ? this.formatEocObj(this.eoc) : "";
    },
    groupTitle() {
      return this.group ? this.group.topic.type : "";
    },
    pdfOptions() {
      return {
        image: { type: "jpeg", quality: 1 },
        margin: 12,
        html2canvas: { scale: 2.5 }
      };
    },
    pdfSingle() {
      const filename = this.document
        ? `${this.modalTitle} - ${this.formatDateTimeSql(
            this.document.effectiveDate
              ? this.document.effectiveDate
              : this.document.createdAt
          )}.pdf`
        : "";

      return { ...this.pdfOptions, filename };
    },
    pdfGroup() {
      const filename = this.group
        ? `${this.groupTitle} - ${this.formatDateTimeSql(this.group.startDate)}`
        : "";

      return { ...this.pdfOptions, filename };
    },
    linkedDocuments() {
      return this.group.episodesOfCare
        .map(p =>
          p.linkedDocuments
            .sort((a, b) => a.form.name.localeCompare(b.form.name))
            .map(f => ({
              ...f,
              participantId: p.id,
              episodeOfCare: p.episodeOfCare,
              scheduleEventStatus: p.scheduleEventStatus
            }))
        )
        .reduce((acc, val) => acc.concat(val), [])
        .filter(d => d.document);
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 350px;
  background-color: #f5f8fc;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  margin-top: 10px;
  margin-bottom: 10px;
}

.sidebar-inner {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 15px;
}

.sidebar-tab-title {
  border-bottom-width: 3px !important;
  width: 176px;
  font-size: 14px;
  padding-bottom: 10px;
  text-align: center;
  flex-grow: 1;
}

.sidebar-menu-form-item {
  padding-left: 16px;
  min-height: 54px;
  font-size: 16px;
  margin-bottom: 0.5rem;
}
.border-radius-top {
  border-top-right-radius: 0.3rem;
  border-top-left-radius: 0.3rem;
}
.border-radius-bottom {
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.main-container {
  -webkit-box-shadow: -10px 0px 13px -7px #000000a6,
    10px 0px 13px -7px #000000a6, 5px 5px 15px 5px rgba(0, 0, 0, 0);
  box-shadow: -10px 0px 13px -7px #000000a6, 10px 0px 13px -7px #000000a6,
    5px 5px 15px 5px rgba(0, 0, 0, 0);
}
</style>

<style>
.form-group-view-modal .modal-content {
  border: none;
  border-radius: 30px;
}
.document-modal .modal-content {
  background-color: transparent;
}
</style>
